export default {
  CUSTOM_GOAL_MONTHLY_PAYMENT_CALCULATION_REPOSITORY: Symbol.for('CUSTOM_GOAL_MONTHLY_PAYMENT_CALCULATION_REPOSITORY'),
  CALCULATE_CUSTOM_GOAL_MONTHLY_PAYMENT_CALCULATION_QUERY: Symbol.for('CALCULATE_CUSTOM_GOAL_MONTHLY_PAYMENT_CALCULATION_QUERY'),
  CUSTOM_GOAL_FIXED_TIME_CALCULATION_REPOSITORY: Symbol.for('CUSTOM_GOAL_FIXED_TIME_CALCULATION_REPOSITORY'),
  CALCULATE_CUSTOM_GOAL_FIXED_TIME_CALCULATION_QUERY: Symbol.for('CALCULATE_CUSTOM_GOAL_FIXED_TIME_CALCULATION_QUERY'),
};
